<template>
    <div>
        <h5>All Existing Sources</h5>
        <!-- Use of custom tree table for Source -->
        <custom-tree-table :treeTableValue="sourceTreeTable" entity="Source" @editOperation="editSource" @deleteOperation="sourceStore.deleteSource" />

        <!-- Source edit form -->
        <source-form v-if="editDialogForm" @hide-dialog="editDialogForm = false" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { sourceStore } from '../../../../../store/global-stores';
import { storeToRefs } from 'pinia';
import CustomTreeTable from '../../../components/CustomTreeTable.vue';
import SourceForm from './SourceForm.vue';

const { sourceTreeTable } = storeToRefs(sourceStore);
const editDialogForm = ref(false);

onMounted(() => {
    sourceStore.fetchAllSources();
});

const editSource = (src) => {
    sourceStore.createEditSourceBody(src);
    editDialogForm.value = true;
};
</script>
